export function stringToColor(value: string): string {
    let hash = 0;
    /* eslint-disable no-bitwise */
    for (let i = 0; i < value.length; i += 1) {
        hash = value.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i += 1) {
        const part = (hash >> (i * 8)) & 0xff;
        color += `00${part.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
    return color;
}

// Iniciais do primeiro e do último nome; tolera nome vazio ou com uma palavra só
export function getInitials(name?: string): string {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function stringAvatar(name?: string) {
    return {
        sx: { bgcolor: stringToColor(name || '') },
        children: getInitials(name),
    };
}
